import React, { useEffect, useState } from "react";
import axios from "axios";
// require('dotenv').config();
const AdminJobPanel = () => {
  const [formData, setFormData] = useState({
    title: "",
    category: "",
    type: "",
    location: "",
    description: "",
    requirements: "",
  });

  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch jobs
  const fetchJobs = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/api/jobs`);
      setJobs(res.data);  
    } catch (err) {
      console.error("Error fetching jobs", err);
    }
  };

  useEffect(() => {
    fetchJobs();
  }, []);

  // Submit job
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_API_URL}/api/jobs`, formData);
      setFormData({
        title: "",
        category: "",
        type: "",
        location: "",
        description: "",
        requirements: "",
      });
      fetchJobs();
    } catch (err) {
      console.error("Error creating job", err);
    } finally {
      setLoading(false);
    }
  };

  // Delete job
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this job?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_API_URL}/api/jobs/${id}`);
        fetchJobs();
      } catch (err) {
        console.error("Delete error", err);
      }
    }
  };

  return (
    <div className="min-h-screen bg-white text-gray-800">
      {/* <h2 className="text-3xl font-[500] mb-6 text-pink-900 font-[Poppins]">Add Job Panel</h2> */}
      <h1 className="text-3xl font-bold mb-4">Post Job</h1>

      {/* Form */}
      <form
        onSubmit={handleSubmit}
        className="  rounded-lg  mb-10 space-y-4 mt-5"
      >
        {["title", "category", "type", "location"].map((field) => (

          <input
            key={field}
            type="text"
            placeholder={field[0].toUpperCase() + field.slice(1)}
            value={formData[field]}
            onChange={(e) => setFormData({ ...formData, [field]: e.target.value })}
            className="w-full p-3 rounded border outline-none border-gray-300 focus:outline-indigo-500"
            required
          />
        ))}
        <label htmlFor=""></label>
        <textarea
          placeholder="Job Description"
          value={formData.description}
          onChange={(e) => setFormData({ ...formData, description: e.target.value })}
          className="w-full p-3 rounded border border-gray-300 h-28 resize-none"
          required
        />
        <textarea
          placeholder="Requirements"
          value={formData.requirements}
          onChange={(e) => setFormData({ ...formData, requirements: e.target.value })}
          className="w-full p-3 rounded border border-gray-300 h-28 resize-none"
          required
        />
        <button
          type="submit"
          className="bg-pink-600 cursor-pointer text-white px-6  py-3 rounded hover:bg-pink-400"
          disabled={loading}
        >
          {loading ? "Posting..." : "Post Job"}
        </button>
      </form>

      {/* Job List */}
      <h3 className="text-2xl font-semibold mb-4">Current Jobs</h3>
      <div className="grid md:grid-cols-2 gap-5">
        {jobs.map((job) => (
          <div
            key={job.id}
            className="bg-white p-4 rounded border shadow-sm relative"
          >
            <h4 className="text-xl font-bold text-black">{job.title}</h4>
            <p className="text-sm text-gray-500">
              {job.category} | {job.type} | {job.location}
            </p>
            <p className="text-sm mt-2 text-gray-700">{job.description.slice(0, 100)}...</p>

            <button
              onClick={() => handleDelete(job.id)}
              className="absolute cursor-pointer top-4 right-4 bg-red-500 hover:bg-red-600 text-white text-xs px-3 py-1 rounded"
            >
              Delete
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminJobPanel;
